var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"member-site-pie-chart-wrap"},[(_vm.tabName === 'sitePie')?_c('pie',{attrs:{"tabName":_vm.navName}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }